import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column, ColumnFilterApplyTemplateOptions, ColumnFilterClearTemplateOptions } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import OrigemProdutoService from "service/administracao/cadastro/produto/OrigemProdutoService";
import { TextMatchModeOptions, filterApplyTemplate } from "utils/filterUtils";

const origemService = new OrigemProdutoService();

export default function OrigemProdutoListagem() {


    const defaultFilters: DataTableFilterMeta = {
        nome: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        codigo: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        }
    }

    

    return (

        <BaseListagem ordenacao="id.codigo,ASC" service={origemService} urlService="/origemProduto" tituloPagina={'Origens'} defaultFilters={defaultFilters} showClearFilterButton nome="origem" >
            <Column field="codigo" header="Código" style={{ width: '10em' }} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="nome" header="Nome" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} 
                headerStyle={{ width: "100%" }} />
        </BaseListagem>
    )
}
